import { parseAsInteger, parseAsString, parseAsStringLiteral } from 'nuqs'

export const SORT_ORDER = ['asc', 'desc'] as const
export const sortParsers = { sort: parseAsString, order: parseAsStringLiteral(SORT_ORDER) }

export const paginationSizes = [25, 50, 100]
export const defaultPaginationSize = paginationSizes[0]

const PAGINATION_PREFERENCE_KEY = 'pagination_preferences'

export const getUserPaginationPreference = (): number => {
  if (typeof window === 'undefined') return defaultPaginationSize
  try {
    const stored = localStorage.getItem(PAGINATION_PREFERENCE_KEY)
    if (!stored) return defaultPaginationSize

    const storedLimit = parseInt(stored, 10)
    return paginationSizes.includes(storedLimit) ? storedLimit : defaultPaginationSize
  } catch (error) {
    console.warn('Failed to read pagination preference:', error)
    return defaultPaginationSize
  }
}

export const setUserPaginationPreference = (limit: number): void => {
  if (typeof window === 'undefined') return
  try {
    if (!paginationSizes.includes(limit)) return
    localStorage.setItem(PAGINATION_PREFERENCE_KEY, limit.toString())
  } catch (error) {
    console.warn('Failed to save pagination preference:', error)
  }
}

export const createPaginationParsers = () => ({
  page: parseAsInteger.withDefault(1),
  limit: parseAsInteger.withDefault(getUserPaginationPreference())
})
